import { Injectable } from '@angular/core';
import { WAYGATE_XML_COMMENT_TAG_NAME, WAYGATE_XML_COMMENT_TAG_VALUE } from "../app.constants";

@Injectable({
  providedIn: 'root'
})
export class XmlReaderService {

  constructor() { }

  async extractCommentFromXml(xmlFile: File): Promise<string | null> {
    try {
      const xmlText = await xmlFile.text();
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlText, "application/xml");

      const elements = xmlDoc.getElementsByTagName(WAYGATE_XML_COMMENT_TAG_NAME);

      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        if (element.getAttribute('TAG') === WAYGATE_XML_COMMENT_TAG_VALUE) {
          return element.textContent;
        }
      }
      return null;

    } catch (error) {
      console.error("Error reading XML file:", xmlFile.name, error);
      return null;
    }
  }
}
